module.exports = __webpack_public_path__ + "f90083ab8a4e0637093bf2e8672ba500.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/g/g06.jpg
// module id = 568
// module chunks = 0